{
  "name": "join-program-web-app",
  "author": "Endeavour Platforms",
  "homepage": "https://endeavour.nl",
  "version": "2.3.0",
  "description": "The Angular client web app for the Join Program platform.",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:test": "ng build -c test",
    "build:acc": "ng build -c acc",
    "build:prod-nl": "ng build -c prod-nl",
    "build:prod-de": "ng build -c prod-de",
    "build:prod-fr": "ng build -c prod-fr",
    "bump": "git reset && git add ./CHANGELOG.md ./README.md && npx yarn version --new-version",
    "watch": "ng build --watch --configuration development",
    "test:dev:once": "TEST_ENV=dev:once jest",
    "test:dev:watch": "TEST_ENV=dev:watch jest --watch",
    "test:ci:sonar": "TEST_ENV=ci:sonar jest --ci",
    "test:ci:other": "TEST_ENV=ci:other jest --ci",
    "lint": "npx ng lint",
    "lint:fix": "npx ng lint --fix"
  },
  "private": true,
  "engines": {
    "node": ">=24.15.0 <25",
    "npm": ">=11 <12"
  },
  "dependencies": {
    "@angular/common": "22.2.1",
    "@angular/compiler": "22.2.1",
    "@angular/core": "22.2.1",
    "@angular/forms": "22.2.1",
    "@angular/platform-browser": "22.2.1",
    "@angular/platform-browser-dynamic": "22.2.1",
    "@angular/router": "22.2.1",
    "@apollo/client": "^4.3.0",
    "@bugsnag/js": "^8.10.0",
    "@bugsnag/plugin-angular": "^8.10.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "apollo-angular": "^14.2.0",
    "colord": "^2.9.3",
    "date-fns": "^2.30.0",
    "graphql": "^16.7.1",
    "graphql-ws": "^6.2.2",
    "ramda": "^0.30.1",
    "rxjs": "^7.8.1",
    "swiper": "^12.1.2",
    "tslib": "^2.6.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.0",
    "@angular/cli": "22.2.0",
    "@angular/compiler-cli": "22.2.1",
    "@join-program/angular-dev-tools": "^3.1.0",
    "@pxlwidgets/eslint-config-angular": "^22.0.1",
    "@types/jest": "^30.0.0",
    "@types/markdown-it": "^12.2.3",
    "@types/node": "^24.13.3",
    "@types/ramda": "^0.30.2",
    "angular-eslint": "^22.5.0",
    "eslint": "^10.0.0",
    "jest": "^30.5.1",
    "jest-environment-jsdom": "^30.5.1",
    "jest-preset-angular": "^17.0.0",
    "jsdom": "^26.1.0",
    "npm-run-all": "^4.1.5",
    "ts-jest": "^29.4.12",
    "ts-node": "^10.9.1",
    "typescript": "~6.0.3"
  }
}
